/**
 * Studio Service - Servicio de Studios
 * Los studios legacy (/studio/*) fueron migrados a v2 (/api/v2/studios/).
 * Solo quedan aquí métodos de chat suggestions y health check.
 */

import { ApiServiceBase } from '../core/ApiService';

export class StudioService extends ApiServiceBase {
  /**
   * Obtiene preguntas sugeridas usando IA (servicio simplificado)
   * Ahora soporta last_ai_response para generar follow-ups contextuales
   * Las preguntas ya seleccionadas se extraen automáticamente del historial de conversación
   */
  async getAISuggestedQuestions(data: {
    document_ids: string[];
    conversation_id?: string; // El historial de conversación contiene preguntas ya seleccionadas
    last_ai_response?: string; // Nuevo parámetro para follow-ups
  }): Promise<{
    success: boolean;
    suggestions: string[];
    error?: string;
    quality?: {
      // FASE 4: Información de calidad del contexto
      warning?: boolean;
      using_metadata_only?: boolean;
      documents_with_summary?: number;
      total_documents?: number;
    };
    generation_metadata?: {
      // Nueva: metadata de generación para transparencia
      dynamic_threshold?: number;
      total_documents?: number;
      documents_with_summary?: number;
      avg_summary_length?: number;
      summary_coverage?: number;
      questions_generated?: number;
      questions_filtered?: number;
      questions_final?: number;
      cache_used?: boolean;
      general_questions_count?: number;
      followup_questions_count?: number;
    };
  }> {
    return this.request('/chat/suggested-questions', {
      method: 'POST',
      body: JSON.stringify(data),
    });
  }

  /**
   * Obtiene studios sugeridos usando IA (similar a preguntas sugeridas)
   * Soporta last_ai_response para generar follow-ups contextuales
   */
  async getAISuggestedTasks(data: {
    document_ids: string[];
    conversation_id?: string;
    last_ai_response?: string;
  }): Promise<{
    success: boolean;
    tasks: string[];
    error?: string;
  }> {
    return this.request('/chat/suggested-tasks', {
      method: 'POST',
      body: JSON.stringify(data),
    });
  }

  /**
   * Health check
   */
  async healthCheck(): Promise<{ status: string; message: string; version: string }> {
    return this.request('/health');
  }
}
